import {
  loginByUsername,
  loginByAuthtoken,
  logout,
  getUserInfo,
  getUserRole
} from '@/api/login'
import {
  getToken,
  setToken,
  removeToken
} from '@/utils/auth'
import {
  Message
} from 'element-ui'

const user = {
  state: {
    token: getToken(),
    user: {},
    tree: [],
    error: false,
    prolxid: '0',
    proytid: '0',
    promjid: "",
    mj1:null,
    mj2:null,
    name:null,
    idcard:null,
    code: '0',
    codeName: '全国',
    userTel: '',
    xzcode: "",
    userName:''
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USER: (state, user) => {
      state.user = user
    },
    SET_TREE: (state, tree) => {
      state.tree = tree
    },
    SET_ERROR: (state) => {
      state.error = true
    },
    SET_PROLXID: (state, val) => {
      state.prolxid = val;
    },
    SET_PROYTID: (state, val) => {
      state.proytid = val;
    },
    SET_PROMjID: (state, val) => {
      state.promjid = val;
    },
    //面积区间
    SET_MjQUJIAN: (state, val) => {
      console.log(val);
      state.mj1 = val.mj1;
      state.mj2 = val.mj2;
      state.name = val.name;
      state.idcard = val.idcard;
    },

    SET_CODE: (state, val) => {
      state.code = val;
    },
    SET_CODENAME: (state, val) => {
      state.codeName = val;
    },
    SET_USER1: (state, val) => {
      state.userTel = val;
      window.sessionStorage.setItem("userTel",val);
    },
    SET_USERNAME: (state, val) => {
      state.userName = val;
    },
    SET_XZCODE: (state, val) => {
      state.userTel = val;
    },
    SET_XZCODE1: (state, val) => {
      state.xzcode = val;
    }
  },

  actions: {
    // 晋来办登录
    LoginByAuthtoken({
      commit
    }, authtoken) {
      return new Promise((resolve, reject) => {
        loginByAuthtoken(authtoken).then(response => {
          const data = response.data;
          console.log('response.data...' + JSON.stringify(response.data))
          if (data.success) {
            console.log('user.js接口成功，开始设置token。。。。。。。。。。。。。。。。')
            commit('SET_TOKEN', data.data.token)
            setToken(response.data.data.token)
            resolve(data.success)
          } else {
            Message.error(data.msg);
            reject()
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 用户名登录
    LoginByUsername({
      commit
    }, userInfo) {
      // const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        loginByUsername(userInfo).then(response => {
          const data = response.data
          if (data.success) {
            commit('SET_TOKEN', data.data.token)
            setToken(response.data.data.token)
            resolve(data.success)
          } else {
            Message.error(data.msg);
            reject()
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetUserInfo({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        getUserInfo(state.token).then(response => {
          const data = response.data;
          if (data.success) {
            commit('SET_USER', data.data)
            resolve()
          } else {
            Message.error(data.msg);
            reject()
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户角色
    GetUserRole({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        getUserRole(state.token).then(response => {
          const data = response.data
          if (data.success) {
            commit('SET_TREE', data.data)
            resolve(data.data)
          } else {
            reject()
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 退出
    LogOut({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        logout().then(() => {
          commit('SET_TOKEN', '')
          commit('SET_TREE', [])
          commit('SET_USERNAME','')
          commit('SET_USER1','')
          window.sessionStorage.removeItem("userName");
          window.sessionStorage.removeItem('userTel');
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js